module.exports = __webpack_public_path__ + "img/tek-experts.1e09d9bf.png";